import React from "react";
import styles from "./CurrencyModal.module.scss";
import GenericModal from "../../common/genericModal";

export default function CurrencyModal({ isOpen, toggle, setSelected,selected }) {
  const options = ["USD","euro", "Dollar","PKR"];
  return (
    <GenericModal isOpen={isOpen} toggle={toggle}>
      <div className={styles.heading}>Default Currency</div>
      <div className={styles.dropdowncontent}>
        {options.map((option) => (
          <div
            onClick={(e) => {
              setSelected(option);
              toggle();
            }}
            className={`${styles.dropdownitems} ${selected === option ? styles.active : ""}`}
          >
            {option}
          </div>
        ))}
      </div>
    </GenericModal>
  );
}
